<template>
  <div class="group">
    <div :class="{item: true, selected: isSelected}" ref="item">
      <!-- options -->
      <div class="option">
        <!-- option :: folder -->
        <button type="button" title="toggle"
          v-if="hasChildren && option.folder"
          :class="{btnOpen: true, isOpen: open}"
          @click.stop="openMenu">
          <img src="~@/assets/img/ico_arrow.svg" alt="">
        </button>
        <span v-else class="blankFolder"></span>
        <!-- //option :: folder -->
        <!-- option :: checkbox -->
        <span v-if="option.checkbox" class="checkbox">
          <input type="checkbox" name="checkCategory" :id="`check_${item.id}`" :value="item.id" v-model="checked">
          <label :for="`check_${item.id}`"><span class="blind">check</span></label>
        </span>
        <!-- //option :: checkbox -->
        <!-- option :: radio -->
        <span v-if="option.selected" class="icoSelect checkbox radio">
          <input type="radio" name="selectCategory" :id="`select_${item.id}`" :value="item.id" v-model="state.selected" @change="selectedItem(item)">
          <label :for="`select_${item.id}`"><span class="blind">check</span></label>
        </span>
        <!--// option :: radio -->
      </div>
      <!-- //options -->
      <!-- label -->
      <div class="listLabel" @click.stop="onClickLabel">
        <input ref="label" type="text" :class="{input: true, isEdit: editLabel}" v-model="item.text" @focusout="endEditLabel">
        <div v-if="!editLabel" class="input">
          {{ item.text }}
        </div>
      </div>
      <!-- label -->

      <!-- edit -->
      <div v-if="option.editItem && !editLabel" class="edit">
        <div class="editGroup">
          <button type="button" title="edit category name" @click.stop="startEditLabel"><img src="~@/assets/img/ico_pencil.svg" alt=""></button>
          <button v-if="depth < 2" type="button" title="add category" @click.stop="addChildItem(item)"><img src="~@/assets/img/ico_plus.svg" alt=""></button>
          <button type="button" title="remove category" @click.stop="removeChildItem(item, rootIndex, index)"><img src="~@/assets/img/ico_minus.svg" alt=""></button>
        </div>
      </div>
      <!-- edit -->
    </div>
    <div v-if="hasChildren" v-show="open" class="list">
      <CategoryItem
        v-for="(item, index) in item.children"
        :key="item.id"
        :item="item"
        :rootIndex="rootIndex"
        :index="index"
        :option="option"
        :state="state"
        :depth="childrenDepth"
        :data-depth="childrenDepth"
        :setCheckItem="setCheckItem"
        @addItem="addChildItem"
        @removeItem="removeChildItem"
        @selected="selectedItem" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategoryItem',
  props: [
    'item',
    'rootIndex',
    'index',
    'depth',
    'option',
    'state',
    'setCheckItem'
  ],
  data () {
    return {
      open: this.state.open,
      editLabel: this.state.editLabel,
      // checked,
      childrenDepth: this.depth + 1,
      newItem: {}
    }
  },
  computed: {
    checkCategory () {
      return this.item
    },
    hasChildren () {
      return this.item.children && this.item.children.length > 0
    },
    checkedAll () {
      return this.state.checked
    },
    isSelected () {
      return this.state.selected === this.item.id
    },
    checked: {
      get () {
        if (!this.option.checkAll) {
          return this.setCheckItem.includes(this.item.id)
        } else {
          return this.state.checked
        }
      },
      set (isChecked) {
        const data = { id: this.item.id, isChecked: isChecked }
        this.$store.commit('category/setChecked', data)
      }
    }
  },
  methods: {
    openMenu () {
      this.open = !this.open
    },
    onClickLabel () {
      if (!this.editLabel) {
        this.openMenu()
      }
    },
    startEditLabel () {
      this.editLabel = true
      this.$refs.label.focus()
    },
    endEditLabel () {
      this.editLabel = false
    },
    addChildItem (item) {
      this.$emit('addItem', item)
      if (!this.open) {
        this.open = true
      }
    },
    removeChildItem (item, rootIndex, index) {
      this.$emit('removeItem', item, rootIndex, index)
    },
    /*
    checkedItem (item) {
      this.$emit('checked', item)
    },
    */
    selectedItem (item) {
      this.$emit('selected', item)
    }
  }
}
</script>
